import {
    CREATE_AREA_MASTER_FAILURE,
    CREATE_AREA_MASTER_REQUEST,
    CREATE_AREA_MASTER_SUCCESS,
    CREATE_USER_FORM_AREA_MASTER,
    DELETE_AREA_MASTER_FAILURE,
    DELETE_AREA_MASTER_REQUEST,
    DELETE_AREA_MASTER_SUCCESS,
    FETCH_AREA_MASTER_FAILURE,
    FETCH_AREA_MASTER_REQUEST,
    FETCH_AREA_MASTER_SUCCESS,
    FETCH_SINGLE_AREA_MASTER_FAILURE,
    FETCH_SINGLE_AREA_MASTER_REQUEST,
    FETCH_SINGLE_AREA_MASTER_SUCCESS,
    RESET_USER_ADDRESS_INFO,
    UPDATE_AREA_MASTER_FAILURE,
    UPDATE_AREA_MASTER_REQUEST,
    UPDATE_AREA_MASTER_SUCCESS,
    USER_ADDRESS_INFO_FAILURE,
    USER_ADDRESS_INFO_REQUEST,
    USER_ADDRESS_INFO_SUCCESS,
    USER_STATE_LIST_FAILURE,
    USER_STATE_LIST_REQUEST,
    USER_STATE_LIST_SUCCESS
} from './areaMaster.actionsType';
import axiosCall from '../axiosCall';
import ConstantApi from '../../ConstantApi';

// FETCH AREA MASTER
// method, url, responseType, data, headers, payload, resetFormData, modalClose, getAllData, singlApiArray
export let fetchAreaMaster = () => {
    let config = {
        method: 'get',
        url: ConstantApi.areaMasterGET,
        responseTypeRequest: FETCH_AREA_MASTER_REQUEST,
        responseTypeSuccess: FETCH_AREA_MASTER_SUCCESS,
        responseTypeFailure: FETCH_AREA_MASTER_FAILURE
    };
    return axiosCall(config);
};

//Fetch Country List
export let fetchAddressInfoList = (codeId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${codeId}`,
        payload: codeId,
        responseTypeRequest: USER_ADDRESS_INFO_REQUEST,
        responseTypeSuccess: USER_ADDRESS_INFO_SUCCESS,
        responseTypeFailure: USER_ADDRESS_INFO_FAILURE
    };
    return axiosCall(config);
    // console.log('codeId :>> ', codeId)
};

//Fetch State List
export let fetchStateInfoList = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.StateList}`,
        responseTypeRequest: USER_STATE_LIST_REQUEST,
        responseTypeSuccess: USER_STATE_LIST_SUCCESS,
        responseTypeFailure: USER_STATE_LIST_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createAreaUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_AREA_MASTER, updatePayload: { key, value } });
    };
};

// CREATE AREA MASTER
export let createAreaMaster = (userform, modalClose) => {
    let { country, city, area, ipv4, pincode, state } = userform;
    let today = new Date();
    let data = JSON.stringify({
        fldFKCountry: country.fldId,
        fldCountry: country.fldDescription,
        fldFKState: state.fldId,
        fldState: state.fldStateName,
        fldFKCity: city.fldId,
        fldCity: city.fldDescription,
        fldFKArea: area.fldId,
        FldStateCode: 0,
        FldStateShortCode: 'string',
        fldArea: area.fldDescription,
        fldFKPincode: pincode.fldId,
        fldPincode: pincode.fldDescription,
        fldIsActive: true,
        fldEnteredSysId: ipv4,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString()
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.areaMasterPOST}`,
        responseTypeRequest: CREATE_AREA_MASTER_REQUEST,
        responseTypeSuccess: CREATE_AREA_MASTER_SUCCESS,
        responseTypeFailure: CREATE_AREA_MASTER_FAILURE,
        resetFormData: RESET_USER_ADDRESS_INFO,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchAreaMaster()
    };
    return axiosCall(config);
};

// GET SINGLE AREA MASTER
export let getSingleAreaMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.areaMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_AREA_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_AREA_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_AREA_MASTER_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateAreaMaster = (id, formData) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldFKCountry: formData.country.fldId,
        fldCountry: formData.country.fldDescription,
        fldFKState: formData.state.fldId,
        fldState: formData.state.fldStateName,
        fldFKCity: formData.city.fldId,
        fldCity: formData.city.fldDescription,
        fldFKArea: formData.area.fldId,
        fldArea: formData.area.fldDescription,
        fldStateCode: formData.fldStateCode,
        fldStateShortCode: formData.fldStateShortCode,
        fldFKPincode: formData.pincode.fldId,
        fldPincode: formData.pincode.fldDescription,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString()
        // fldDeletedBy: 0,
        // fldDeletedDt: '0001-01-01T00:00:00'
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.areaMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_AREA_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_AREA_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_AREA_MASTER_FAILURE,
        resetFormData: RESET_USER_ADDRESS_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchAreaMaster()
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteAreaMaster = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.areaMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_AREA_MASTER_REQUEST,
        responseTypeSuccess: DELETE_AREA_MASTER_SUCCESS,
        responseTypeFailure: DELETE_AREA_MASTER_FAILURE,
        modalClose: true,
        getAllData: fetchAreaMaster()
    };
    return axiosCall(config);
};
